/* Fluffums Build a Bundle (spec section 7).
   Client-side selection, milestone bar, sticky tray, add to cart.
   Pricing here mirrors the three native automatic discounts on the Singles collection
   (scripts/CreateTierDiscounts.ts, minimum quantity 4 / 8 / 12): each milestone has a
   dollar price and every extra ball between milestones costs the current tier's per-ball
   rate. Shopify applies the discount at checkout on its own; nothing here depends on an
   app or a plan (Brian, 2026-10-19). Every line added at or above the first milestone
   carries _set (one id per set) so the cart can show the lines under one set header. */
(function () {
  const root = document.querySelector('[data-build-your-set]');
  if (!root) return;

  const pct = (saving, was) => (was > 0 ? Math.round((saving / was) * 100) : 0) + '%';
  const money = (cents) => '$' + (cents / 100).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  const tiers = JSON.parse(root.dataset.tiers || '[]');
  const MILESTONES = tiers.map((t) => t.count);
  const FIRST = MILESTONES[0] || 4; // first set-price milestone; any count can be added (Brian, 2026-10-14)
  const M2 = MILESTONES[1] || FIRST * 2;
  const TOP = MILESTONES[MILESTONES.length - 1] || 12;
  const WORDS = ['zero', 'one', 'two', 'three', 'four', 'five', 'six', 'seven', 'eight', 'nine', 'ten', 'eleven', 'twelve'];
  const word = (n) => WORDS[n] || String(n);
  const singlePrice = parseInt(root.dataset.singlePrice, 10) || 0;
  const ADD_LABEL = root.dataset.addLabel || 'Add bundle to cart';
  const LABEL_TOP = root.dataset.labelTop || 'Biggest saving';

  const cards = Array.from(root.querySelectorAll('[data-card]'));
  const byHandle = new Map(cards.map((c) => [c.dataset.handle, c]));
  const fill = root.querySelector('[data-fill]');
  const message = root.querySelector('[data-message]');
  const milestoneEls = root.querySelectorAll('[data-milestone]');
  const picks = root.querySelector('[data-picks]');
  const countEl = root.querySelector('[data-count]');
  const countWord = root.querySelector('[data-count-word]');
  const wasEl = root.querySelector('[data-was]');
  const nowEl = root.querySelector('[data-now]');
  const saveEl = root.querySelector('[data-save]');
  const eachEl = root.querySelector('[data-each]');
  const addBtn = root.querySelector('[data-add]');
  const status = root.querySelector('[data-status]');
  const tray = root.querySelector('[data-tray]');
  const lb = root.querySelector('[data-lightbox]');
  const lbImg = lb && lb.querySelector('[data-lb-img]');
  const lbTitle = lb && lb.querySelector('[data-lb-title]');
  const lbPrice = lb && lb.querySelector('[data-lb-price]');
  const lbQty = lb && lb.querySelector('[data-lb-qty]');
  const lbPlus = lb && lb.querySelector('[data-lb-plus]');
  const lbSoon = lb && lb.querySelector('[data-lb-soon]');
  const lbMore = lb && lb.querySelector('[data-lb-more]');
  let lbHandle = null;

  // selection: handle -> qty
  const selected = new Map();
  let lastTier = 0;

  function setPrice(n) {
    let tier = null;
    for (const t of tiers) if (t.price !== null && n >= t.count) tier = t;
    if (!tier) return null;
    const perBall = Math.round(tier.price / tier.count);
    return tier.price + (n - tier.count) * perBall;
  }
  function tierIndex(n) {
    let i = 0;
    MILESTONES.forEach((m, k) => { if (n >= m) i = k + 1; });
    return i;
  }
  function fillPercent(n) {
    if (n <= 0) return 0;
    if (n <= FIRST) return (n / FIRST) * 33.33;
    if (n <= M2) return 33.33 + ((n - FIRST) / (M2 - FIRST)) * 33.33;
    return 66.66 + Math.min(1, (n - M2) / (TOP - M2)) * 33.34;
  }
  function count() {
    let c = 0;
    selected.forEach((q) => (c += q));
    return c;
  }
  function singlesTotal() {
    let s = 0;
    selected.forEach((q, h) => (s += q * (parseInt(byHandle.get(h).dataset.price, 10) || 0)));
    return s;
  }

  // Milestone labels: price at each milestone and the saving against singles.
  milestoneEls.forEach((m) => {
    const n = parseInt(m.dataset.milestone, 10);
    const label = m.querySelector('[data-mlabel]');
    const p = setPrice(n);
    const t = tiers.find((x) => x.count === n);
    const saving = p === null ? 0 : n * singlePrice - p;
    // A named milestone (Medium load / Large load / Extra large load, Brian 10/22) replaces the dollar total.
    const head = m.dataset.mname || (n === TOP && (!t || t.price === null) ? LABEL_TOP : money(p));
    const each = p === null ? '' : `<small class="bys__meach">${money(Math.round(p / n))} each</small>`;
    label.innerHTML = `<strong>${n}</strong><span>${head}</span>` + each + (saving > 0 ? `<small>save ${pct(saving, n * singlePrice)}</small>` : '');
  });

  // the next step as a difference: "3 more for $22.00" (field tests favor the step framing)
  function stepTo(n, target) {
    const next = setPrice(target);
    const now = setPrice(n);
    if (next === null || now === null) return `${target - n} more`;
    return `${target - n} more for ${money(next - now)}`;
  }
  function messageFor(n, saving, was) {
    if (n === 0) return `Pick any designs. ${word(FIRST).charAt(0).toUpperCase() + word(FIRST).slice(1)} or more unlocks the bundle price.`;
    if (n < FIRST) return `${FIRST - n} more unlocks the bundle price.`;
    if (n < M2) return `Bundle price unlocked, you save ${pct(saving, was)}. ${stepTo(n, M2)} saves more.`;
    if (n < TOP) return `Bundle of ${word(M2)} price, you save ${pct(saving, was)}. ${stepTo(n, TOP)} is the biggest saving.`;
    return `Biggest saving: ${pct(saving, was)} off.`;
  }

  function render() {
    const n = count();
    const was = singlesTotal();
    const now = setPrice(n);
    const saving = now === null ? 0 : was - now;

    fill.style.width = fillPercent(n) + '%';
    milestoneEls.forEach((m) => m.classList.toggle('is-reached', n >= parseInt(m.dataset.milestone, 10)));
    message.textContent = messageFor(n, saving, was);

    cards.forEach((c) => {
      const q = selected.get(c.dataset.handle) || 0;
      c.classList.toggle('is-chosen', q > 0);
      const qty = c.querySelector('[data-qty]');
      const minus = c.querySelector('[data-minus]');
      if (qty) qty.textContent = q;
      if (minus) minus.disabled = q === 0;
    });

    picks.innerHTML = '';
    selected.forEach((q, h) => {
      const c = byHandle.get(h);
      const el = document.createElement('button');
      el.type = 'button';
      el.className = 'bys__pick';
      el.dataset.remove = h;
      el.setAttribute('aria-label', `Remove ${c.dataset.title}`);
      el.innerHTML = `<img src="${c.dataset.img}" alt="" width="48" height="48" loading="lazy">` + (q > 1 ? `<span class="bys__pick-qty">${q}</span>` : '') + '<span class="bys__pick-x" aria-hidden="true">&times;</span>';
      picks.appendChild(el);
    });

    countEl.textContent = n;
    countWord.textContent = n === 1 ? 'design' : 'designs';
    if (now === null) {
      wasEl.hidden = true;
      nowEl.textContent = n ? money(was) : '';
      saveEl.hidden = true;
    } else {
      wasEl.hidden = false;
      wasEl.textContent = money(was);
      nowEl.textContent = money(now);
      saveEl.hidden = false;
      saveEl.textContent = `You save ${pct(saving, was)}`;
    }
    // per-ball price so the drop is visible as the set grows (Brian, 2026-10-13)
    if (eachEl) {
      const total = now === null ? was : now;
      eachEl.hidden = n === 0;
      if (n > 0) eachEl.textContent = `${money(Math.round(total / n))} each`;
    }

    if (n === 0) {
      addBtn.disabled = true;
      addBtn.textContent = 'Add to cart';
    } else if (n < FIRST) {
      addBtn.disabled = false;
      addBtn.textContent = `Add to cart · ${money(was)}`;
    } else {
      addBtn.disabled = false;
      addBtn.textContent = `${ADD_LABEL} · ${money(now)}`;
    }
    tray.classList.toggle('is-active', n > 0);
    if (lb && lb.open) renderLightbox();

    const t = tierIndex(n);
    if (t > lastTier && t > 0) {
      tray.classList.remove('is-celebrating');
      void tray.offsetWidth;
      tray.classList.add('is-celebrating');
    }
    lastTier = t;
  }

  function change(handle, delta) {
    const c = byHandle.get(handle);
    if (!c || c.dataset.available !== 'true') return;
    const q = (selected.get(handle) || 0) + delta;
    if (q <= 0) selected.delete(handle);
    else selected.set(handle, Math.min(q, TOP));
    render();
  }
  function preload(handles) {
    selected.clear();
    handles.map((h) => h.trim()).filter(Boolean).forEach((h) => {
      const c = byHandle.get(h);
      if (c && c.dataset.available === 'true') selected.set(h, (selected.get(h) || 0) + 1);
    });
    render();
  }

  // Lightbox: a closer look at one design, with its own add button (10/22, the product page
  // left the funnel). Native <dialog>; the plus button reuses change() so the tray updates too.
  function renderLightbox() {
    if (!lb || !lbHandle) return;
    const q = selected.get(lbHandle) || 0;
    const label = lbPlus.dataset.label || (lbPlus.dataset.label = lbPlus.textContent);
    lbQty.hidden = q === 0;
    lbQty.textContent = q ? `${q} in your bundle` : '';
    lbPlus.textContent = q ? 'Add another' : label;
  }
  function openLightbox(card) {
    if (!lb) return;
    lbHandle = card.dataset.handle;
    // Show the card's already-loaded photo at once, then swap in the large one when it arrives,
    // so the dialog never opens on the previous design's picture (Brian, 10/22).
    const thumb = card.querySelector('.bys__img');
    lbImg.src = (thumb && (thumb.currentSrc || thumb.src)) || card.dataset.img;
    lbImg.alt = card.dataset.title;
    const large = card.dataset.imgLarge;
    if (large) {
      const pre = new Image();
      pre.onload = () => { if (lbHandle === card.dataset.handle && lb.open) lbImg.src = large; };
      pre.src = large;
    }
    lbTitle.textContent = card.dataset.title;
    lbPrice.textContent = money(parseInt(card.dataset.price, 10) || 0);
    const ok = card.dataset.available === 'true';
    lbPlus.hidden = !ok;
    lbSoon.hidden = ok;
    if (lbMore) lbMore.href = card.dataset.url || '#';
    renderLightbox();
    if (typeof lb.showModal === 'function') lb.showModal();
    else lb.setAttribute('open', '');
  }
  if (lb) {
    lb.addEventListener('click', (e) => { if (e.target === lb) lb.close(); });
    // The close event is queued a tick late; if another design was opened in the meantime, leave it be.
    lb.addEventListener('close', () => { if (lb.open) return; lbHandle = null; lbImg.removeAttribute('src'); });
  }

  root.addEventListener('click', (e) => {
    const zoom = e.target.closest('[data-zoom]');
    const lbp = e.target.closest('[data-lb-plus]');
    const lbc = e.target.closest('[data-lb-close]');
    if (zoom) { openLightbox(zoom.closest('[data-card]')); return; }
    if (lbp) { change(lbHandle, 1); renderLightbox(); return; }
    if (lbc) { lb.close(); return; }
    const plus = e.target.closest('[data-plus]');
    const minus = e.target.closest('[data-minus]');
    const rm = e.target.closest('[data-remove]');
    const pre = e.target.closest('[data-preload]');
    if (plus) change(plus.closest('[data-card]').dataset.handle, 1);
    else if (minus) change(minus.closest('[data-card]').dataset.handle, -1);
    else if (rm) change(rm.dataset.remove, -1);
    else if (pre) preload(pre.dataset.preload.split(','));
  });

  // Deep link: /pages/build-a-bundle?theme=dogs preloads that theme and scrolls to it.
  const theme = new URLSearchParams(location.search).get('theme');
  if (theme) {
    const group = root.querySelector(`[data-group="${CSS.escape(theme)}"]`);
    if (group) {
      preload(Array.from(group.querySelectorAll('[data-card]')).map((c) => c.dataset.handle));
      setTimeout(() => group.scrollIntoView({ behavior: 'smooth', block: 'start' }), 50);
    }
  }

  const uuid = () => (window.crypto && crypto.randomUUID ? crypto.randomUUID() : 'set-' + Date.now() + '-' + Math.random().toString(16).slice(2));

  addBtn.addEventListener('click', async () => {
    const n = count();
    if (n < 1) return;
    addBtn.disabled = true;
    const label = addBtn.textContent;
    addBtn.textContent = 'Adding…';
    status.textContent = '';
    const setId = uuid();
    // Below the first milestone there is no bundle price, so the designs go in as ordinary singles.
    const properties = {};
    if (n >= FIRST) properties._set = setId;
    const items = [];
    selected.forEach((q, h) => items.push({ id: Number(byHandle.get(h).dataset.id), quantity: q, properties }));
    const drawer = document.querySelector('cart-drawer');
    const body = { items };
    if (drawer && typeof drawer.renderContents === 'function') {
      body.sections = drawer.getSectionsToRender().map((s) => s.id);
      body.sections_url = window.location.pathname;
    }
    try {
      const res = await fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/javascript' }, body: JSON.stringify(body) });
      const parsed = await res.json();
      if (!res.ok || parsed.status) throw new Error(parsed.description || parsed.message || 'cart/add failed: ' + res.status);
      selected.clear();
      render();
      if (drawer && typeof drawer.renderContents === 'function') drawer.renderContents(parsed);
      else window.location.href = '/cart';
    } catch (err) {
      addBtn.disabled = false;
      addBtn.textContent = label;
      status.textContent = "Sorry, we couldn't add that bundle. One of those designs may have just sold out. Try removing it, or email us and we'll sort it.";
      console.error('[build-your-set] add failed', err);
    }
  });

  // The tray parks (slides away) once the whole builder block has scrolled off the top, so it never
  // sits over the details sections below the grid, and comes back as soon as the builder is in view.
  // Watching the block itself rather than a 1px marker: a jump or a fast flick can skip a marker
  // without ever changing its intersecting state, and the observer then never fires.
  if ('IntersectionObserver' in window) {
    new IntersectionObserver((entries) => {
      const en = entries[0];
      tray.classList.toggle('is-parked', !en.isIntersecting && en.boundingClientRect.bottom < 0);
    }, { threshold: 0 }).observe(root);
  }

  render();
})();
